import { ReactElement } from 'react';

import { useSelector } from 'react-redux';

import Menu from '@components/Menu';
import MobileHeader from './styled-UI/MobileHeader';

import { RootState } from '../store/store';

import { getLabelFallback } from '@utils/utils';

import clsx from 'clsx';
import { setIsMenuMobileSelected } from '@redux-actions/*';

type Props = {
    children: ReactElement;
    hideMenu?: boolean;
    labelMenu?: string;
    backLabel?: string;
    isOnlineOrders?: boolean;
    onBackButtonClick?: () => void;
};

const PageLayout = ({
    children,
    hideMenu,
    labelMenu,
    backLabel,
    isOnlineOrders = false,
    onBackButtonClick,
}: Props): ReactElement => {
    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const config = useSelector((state: RootState) => state.common.config);
    const isMenuMobileSelected = useSelector((state: RootState) => state.common.isMenuMobileSelected);

    const logout = () => {
        window.open(
            config.pagesUrl.logout
                .replace('{catalogId}', config.catalogId)
                .replace('{langId}', config.langId)
                .replace('{storeId}', config.storeId),

            '_parent'
        );
    };

    const classNames = clsx('page-layout-left-column', hideMenu && isMobile && isMenuMobileSelected && 'mobile');

    return (
        <div className="page-layout">
            <div role="region" aria-label="mobile page title" className={classNames}>
                {hideMenu && isMobile && isMenuMobileSelected ? (
                    <MobileHeader
                        labelMenu={labelMenu}
                        backLabel={backLabel}
                        isOnlineOrders={isOnlineOrders}
                        onBackButtonClick={onBackButtonClick}
                    />
                ) : (
                    <>
                        <Menu />
                        <button
                            role="region"
                            aria-label="Logout button"
                            data-element-id="MyAccount_Logout"
                            className={`primary-button-negative${isMobile ? '-mobile' : ''} black`}
                            onClick={logout}
                        >
                            {getLabelFallback(
                                `${isMobile ? 'LOGOUT_MOBILE_MENU_LABEL' : 'LOGOUT_MENU_LABEL'}`
                            )}
                        </button>
                    </>
                )}
            </div>
            <div className='page-layout-right-column'>{children}</div>
        </div>
    );
};
export default PageLayout;
